$(document).ready(function () {
    (function () {
        const ajaxPathBookingClients = '/action/booking/clients';

        let ajaxLockActive = false;

        $(document).on('click', '#booking_clients_list .booking-client-item', function () {
            if (ajaxLockActive) {
                return false;
            }

            ajaxLockActive = true;

            const wrapper = $('#booking_client_details');
            wrapper.html('<div class="text-center"><img src="/includes/charts/gfx/ajax-loader.gif" alt="Loading..." /></div>');
            const companyId = $(this).data('company-id');
            const domain = $(this).data('domain');

            $.ajax({
                type: 'GET',
                url: `${ajaxPathBookingClients}/${companyId}/${domain}`,
                dataType: 'json'
            }).success(function (data) {
                wrapper.html(data.html);
            }).error(function () {
                wrapper.html(getAlertMessageHtml(domain));
            }).always(function () {
                ajaxLockActive = false;
            });

            return false;
        });

        function getAlertMessageHtml(domain) {
            return `<div class="alert alert-danger fade in" role="alert">
                    <p>Kunne ikke hente kundedetaljer til <b>${domain}</b></p>
                </div>`;
        }
    })();
});